<template>
  <div>
    <template v-if="selectedAccount">
      <b-button @click="handleSelectedAccountClick()" variant="light">
        <AccountIcon :type="selectedAccount.type" />
        {{ selectedAccount.description }}</b-button
      >
    </template>
    <template v-else>
      <b-button @click="handleSelectedAccountClick()" variant="light"
        >Selecione uma conta ou caixa</b-button
      >
    </template>

    <b-modal
      ref="modal"
      title="Selecione uma conta ou caixa"
      header-class="border-bottom-0"
      size="xs"
      hide-footer
    >
      <b-table
        ref="table"
        borderless
        hover
        select-mode="single"
        selectable
        thead-class="d-none"
        :items="accounts"
        :fields="fields"
        @row-selected="selectAccount"
      >
        <template #cell(account)="data">
          <AccountLabel :account="data.item" />
        </template>
      </b-table>
      <br />
    </b-modal>
  </div>
</template>

<script>
import AccountLabel from "@/components/account/sections/AccountLabel";
import AccountIcon from "@/components/account/sections/AccountIcon.vue";

export default {
  components: { AccountLabel, AccountIcon },

  props: {
    value: {},
    onlyAllowed: {
      default: true
    },
    status: {
      default: 1
    },
    exceptId: {
      default: null
    }
  },

  data: () => ({
    selectedAccount: null,
    fields: [{ key: "account", label: "" }]
  }),

  async created() {
    await this.$store.dispatch("account/getAccounts", {});

    this.selectedAccount = this.value;
  },

  computed: {
    accounts() {
      if (this.exceptId == null) {
        return this.onlyAllowed
          ? this.$store.getters["account/allowedAccounts"]
          : this.$store.state.account.accounts;
      } else {
        return this.onlyAllowed
          ? this.$store.getters["account/allowedAccounts"].filter(account => {
              return account.id != this.exceptId;
            })
          : this.$store.state.account.accounts.filter(account => {
              return account.id != this.exceptId;
            });
      }
    }
  },

  watch: {
    value() {
      this.selectedAccount = this.value;
    }
  },

  methods: {
    selectAccount(account) {
      this.selectedAccount = account[0];
      this.$store.commit("orderForm/setAccountId", account[0].id);
      this.$refs.modal.hide();
    },

    handleSelectedAccountClick() {
      this.$refs.modal.show();
    }
  }
};
</script>

<style>
.card-select {
  cursor: pointer;
}

/* .card-selected {
  border-color: #8bc34a;
}

.card-selectable:hover {
  border-color: #8bc34a;
} */
</style>
